// extracted by mini-css-extract-plugin
export default {"ref":"EntityRefBadge_ref__noBNH","link":"EntityRefBadge_link__jVyl6 EntityRefBadge_ref__noBNH","muted":"EntityRefBadge_muted__dVe9n EntityRefBadge_ref__noBNH"};